import React, { useMemo } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useTranslation } from 'react-i18next';
import { RTUData } from '../../types/RtuData';

export const RtuConnectedDevicesCard = ({ data }: { data: RTUData | null | undefined }) => {
  const { t } = useTranslation();

  const devicesMap = data?.rtuDiagnostics?.communication?.modbusDevices?.devices;

  const deviceList = useMemo(() => {
    if (!devicesMap || Object.keys(devicesMap).length === 0) {
      return [];
    }
    return Object.entries(devicesMap).map(([key, device]) => ({
      key,
      name: device.name || key,
      type: device.type || '—',
      ip: device.ip || '—',
      status: device.status || '—',
    }));
  }, [devicesMap]);



  return (
    <Card title={t('rtuDetail.connectivity.modbusDevices', { defaultValue: 'Modbus Devices' })} className="compact-card flat-card">
      <div className="scrollable-card-content p-2">
        <DataTable
          value={deviceList}
          className="p-datatable-sm"
          showGridlines
          size="small"
          style={{ fontSize: '0.8rem' }}
          tableStyle={{ tableLayout: 'auto', width: '100%' }}
          emptyMessage={t('table.noRowsFound', { defaultValue: 'No Modbus Devices Found.' })}
        >
          <Column field="name" header={t('rtuDetail.connectivity.deviceName', { defaultValue: 'Name' })} />
          <Column field="type" header={t('rtuDetail.connectivity.deviceType', { defaultValue: 'Type' })} />
          <Column field="ip" header={t('rtuDetail.connectivity.deviceIp', { defaultValue: 'IP' })} />
          <Column field="status" header={t('rtuDetail.connectivity.deviceStatus', { defaultValue: 'Status' })} />
        </DataTable>
      </div>
    </Card>
  );
};

export default RtuConnectedDevicesCard;
